import type { ReactionType } from "frontend-components";
import type { TFunction } from "i18next";

export function getReactionLabels(t: TFunction): Record<ReactionType, string> {
    return {
        LIKE: t("common.reactions.like"),
        SUPPORT: t("common.reactions.support"),
        CELEBRATE: t("common.reactions.celebrate"),
        APPRECIATE: t("common.reactions.appreciate"),
        INTERESTED: t("common.reactions.interested"),
        ACKNOWLEDGE: t("common.reactions.acknowledge"),
    };
}
